import React from 'react';

function shuffle(array) {
	var currentIndex = array.length,
		temporaryValue,
		randomIndex;
	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	return array;
}

const QuizAnswers = props => {
	const { answers, prevAnswer } = props;
	return (
		<div className="question-section__answers">
			<ul className="question-section__answers-list">
				{shuffle(answers).map(({ value, answer, picRef }) => {
					const selected = prevAnswer === value ? true : false;
					return (
						<li key={value} className="question-section__answer">
							<button
								onClick={() => props.onClick(value, answer)}
								className={`question-section__answer-image-wrapper ${
									selected
										? 'question-section__answer-image-wrapper_selected'
										: null
								}`}>
								<img
									className="question-section__answer-img"
									src={picRef}
									alt=""
								/>
							</button>
							<p>{answer}</p>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default QuizAnswers;



// WEBPACK FOOTER //
// ./src/components/quiz/QuizAnswers.js